import { useContext } from 'react';
import { ScreenScrapeCtx } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeProvider';

export const useSSContext = () => {
  const ctx = useContext(ScreenScrapeCtx);
  if (!ctx) {
    throw new Error(`Required context doesn't exist`);
  }
  return ctx;
};
